export enum SessionToolMode {
  Login,
  ResetPassword,
  NewPassword,
  TfaConfirmation,
  TfaReset,
}
